var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { STYLE_NAMESPACES } from './consts';
import classNames from 'classnames';
import FocusTrap from 'focus-trap-react';
import { RCTooltipContext } from '../Tooltip';
var RCTooltipContextValue = {
    className: "".concat(STYLE_NAMESPACES, "__rc-tooltip"),
};
var stopPropagation = function (e) {
    return e.stopPropagation();
};
var FocusTrapOptions = {
    clickOutsideDeactivates: true,
    returnFocusOnDeactivate: false,
    escapeDeactivates: false,
    tabbableOptions: { displayCheck: 'none' },
};
var ContextMenuContainer = function (_a) {
    var _b;
    var children = _a.children, _c = _a.isOpen, isOpen = _c === void 0 ? false : _c, maxHeight = _a.maxHeight, dataAttributes = __rest(_a, ["children", "isOpen", "maxHeight"]);
    return (React.createElement(RCTooltipContext.Provider, { value: RCTooltipContextValue },
        React.createElement(FocusTrap, { active: isOpen, focusTrapOptions: FocusTrapOptions },
            React.createElement("ul", __assign({ className: classNames("".concat(STYLE_NAMESPACES, "__list"), (_b = {},
                    _b["".concat(STYLE_NAMESPACES, "-scroll")] = maxHeight,
                    _b)), role: "menu" }, dataAttributes, { style: { maxHeight: "".concat(maxHeight, "px") }, onClick: stopPropagation, onKeyDown: stopPropagation }), children))));
};
export default React.memo(ContextMenuContainer);
